<template>
    <div class="container">
        <div class="title">{{currentStatus[profile.current_state]}}</div>
        <div class="content">
            <div class="line">
                <div class="item">
                    <div class="title"><span>真实姓名</span></div>
                    <div class="value">{{profile.fullname}}</div>
                </div>

                <div class="item">
                    <div class="title"><span>联系电话</span></div>
                    <div class="value">{{profile.mobile}}</div>
                </div>
            </div>

            <div class="line">
                <div class="item">
                    <div class="title">
                        <span>邮箱</span>
                    </div>
                    <div class="value">{{profile.email}}</div>
                </div>

                <div class="item">
                    <div class="title"><span>QQ/微信</span></div>
                    <div class="value">{{profile.qq_or_wechat}}</div>
                </div>
            </div>

            <div class="line">
                <div class="item">
                    <div class="title"><span>擅长语种</span></div>
                    <div class="value">
                        <p v-for="item in profile.adept_lang" :key="item.id" style="font-weight: bold">{{item.name}}</p>
                    </div>
                </div>

                <div class="item">
                    <div class="title"><span>擅长领域</span></div>
                    <div class="value field">
                        <span v-for="item in profile.adept_fields" :key="item.id">{{item.name}}</span>
                    </div>
                </div>
            </div>

            <div class="line">
                <div class="item">
                    <div class="title"><span>所获证书</span></div>
                    <div class="value">
                        <p v-for="item in profile.had_certificates" :key="item.cer_id">
                            <span>{{item.cer_name}}</span><button :title="item.file_name"  @click="downloadFile(item.cer_id, 'cert')">下载</button>
                        </p>
                    </div>
                </div>

                <div class="item">
                    <div class="title"><span>期望费率</span></div>
                    <div class="value">
                        <span v-if="profile.expected_rates">{{profile.expected_rates.rate}}元/1000字 - {{profile.expected_rates.charge_style}}</span>
                        <span>-</span>
                    </div>
                </div>
            </div>


            <div class="line">
                <div class="item">
                    <div class="title"><span>简历</span></div>
                    <div class="value">
                        <p v-if="profile.resume"><span>{{profile.resume.file_name}}</span><button @click="downloadFile(profile.resume.id, 'resume')">下载</button></p>
                    </div>
                </div>

                <div class="item">
                    <div class="title"><span>翻译样例</span></div>
                    <div class="value">
                        <p v-for="item in profile.trans_example" :key="item.id">
                            <span>{{item.file_name}}</span><button @click="downloadFile(item.id, 'trans_example')">下载</button>
                        </p>
                    </div>
                </div>
            </div>

            <div class="again" v-if="profile.current_state == 'censor_refused'">
                <a href="/modify_information">重新提交资料</a>
            </div>
        </div>
    </div>
</template>

<script>
    import {getProfile, downloadTranslatorFile} from "../../api/translator";
    import {userStatus} from "../../utils/statusDict"

    export default {
        name: "material",
        data(){
            return{
                profile:{},
                currentStatus:userStatus(),
            }
        },
        methods:{
            downloadFile(fileId, fileType){
                downloadTranslatorFile(this.profile.user_id, fileType, fileId)
                .then(data=>{
                    console.log(data)
                })
                .catch(res=>{
                    const blob = new Blob([res.data]);
                    const fileName = decodeURI(res.headers.filename);
                    if ('download' in document.createElement('a')) { // 非IE下载
                        const elink = document.createElement('a');
                        elink.download = fileName;
                        elink.style.display = 'none';
                        elink.href = URL.createObjectURL(blob);
                        document.body.appendChild(elink);
                        elink.click();
                        window.URL.revokeObjectURL(elink.href);// 释放URL 对象
                        document.body.removeChild(elink)
                    } else { // IE10+下载
                        navigator.msSaveBlob(blob, fileName)
                    }
                })
            },
            getProfileEvent(){
                getProfile()
                .then(data=>{
                    this.profile = data;
                    if(this.profile.current_state == "had_cooperated" && this.$store.getters.selfInfo.current_state != "had_cooperated"){
                        this.$store.getters.selfInfo.current_state = this.profile.current_state
                    }
                })
                .catch(error=>{
                    console.log(error)
                    this.$message.error(error.data.error)
                })
            }
        },
        created() {
            this.getProfileEvent()
        }
    }
</script>

<style scoped lang="scss">
@import "@/assets/css/translator/material.scss";
</style>